import { useState } from 'react';
import { FAQS } from '@/mocks/faqs';

function FAQItem({ faq }: { faq: typeof FAQS[0] }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`rounded-2xl border transition-all duration-200 cursor-pointer ${
        open ? 'border-[#8A9B85] bg-white' : 'border-stone-200 bg-[#F8F6F3] hover:border-stone-300'
      }`}
      onClick={() => setOpen(!open)}
    >
      <div className="flex items-center justify-between p-6">
        <h4 className="text-stone-800 font-semibold text-base pr-4">{faq.question}</h4>
        <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${open ? 'bg-[#8A9B85]' : 'bg-stone-200'}`}>
          <i className={`${open ? 'ri-subtract-line text-white' : 'ri-add-line text-stone-600'} text-sm`}></i>
        </div>
      </div>
      {open && (
        <div className="px-6 pb-6">
          <p className="text-stone-500 text-sm leading-relaxed">{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-[#8A9B85] text-xs font-bold uppercase tracking-widest">Questions?</span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-800 mt-3 mb-3 md:mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Everything You Need to Know
          </h2>
          <p className="text-stone-500 text-lg">
            Still on the fence? We've got answers.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((faq) => (
            <FAQItem key={faq.id} faq={faq} />
          ))}
        </div>

        <div className="mt-12 text-center bg-[#F8F6F3] rounded-3xl p-10">
          <p className="text-stone-600 font-medium mb-2">Still have questions?</p>
          <p className="text-stone-400 text-sm mb-6">Our team is happy to help — usually responds within a few hours.</p>
          <a
            href="mailto:hello@pawclean.com"
            className="inline-flex items-center gap-2 border-2 border-[#8A9B85] text-[#8A9B85] hover:bg-[#8A9B85] hover:text-white font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-mail-line"></i>
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
